import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 'dashboard',
  loading: false,
  paymentSuccess: false,
  globalError: null,
  globalMessage: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPaymentSuccess: (state, action) => {
      state.paymentSuccess = action.payload;
    },
    setGlobalError: (state, action) => {
      state.globalError = action.payload;
    },
    setGlobalMessage: (state, action) => {
      state.globalMessage = action.payload;
    },
    clearMessages: (state) => {
      state.globalError = null;
      state.globalMessage = null;
    },
  },
});

export const {
  setCurrentPage,
  setLoading,
  setPaymentSuccess,
  setGlobalError,
  setGlobalMessage,
  clearMessages,
} = uiSlice.actions;

export default uiSlice.reducer;